import { bindActionCreators } from "redux";
import { call, put, select, take } from "redux-saga/effects";

import * as apiCaller from "./../../api/apiConnectCaller";
import { globalHistory } from "./../../history";
import AppError from "./../../ultis/AppError";

export const GET_IVRS = "GET_IVRS";
export const GET_IVRS_ERROR = "GET_IVRS_ERROR";
export const GET_IVRS_SUCCESS = "GET_IVRS_SUCCESS";

export const UPDATE_A_IVR = "UPDATE_A_IVR";
export const UPDATE_A_IVR_SUCCESS = "UPDATE_A_IVR_SUCCESS";
export const UPDATE_A_IVR_ERROR = "UPDATE_A_IVR_ERROR";

export const GET_A_IVR_DETAIL = "GET_A_IVR_DETAIL";
export const GET_A_IVR_DETAIL_SUCCESS = "GET_A_IVR_DETAIL_SUCCESS";
export const GET_A_IVR_DETAIL_ERROR = "GET_A_IVR_DETAIL_ERROR";

export const DELETE_A_IVR = "DELETE_A_IVR";
export const DELETE_A_IVR_SUCCESS = "DELETE_A_IVR_SUCCESS";
export const DELETE_A_IVR_ERROR = "DELETE_IVRS_ERROR";

export const CREATE_A_IVR = "CREATE_A_IVR";
export const CREATE_A_IVR_SUCCESS = "CREATE_A_IVR_SUCCESS";
export const CREATE_A_IVR_ERROR = "CREATE_A_IVR_ERROR";

/**
 * Reducer
 */

const initialState = {
  ivrs: [],
  ivr: {},
  error: false,
  loading: false,
};

export const ivrsReducer = (state = initialState, action) => {
  // if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
  //     console.log(action)
  // }
  switch (action.type) {
    case GET_IVRS:
      return {
        ...state,
        ivrs: [],
        loading: false,
      };
    case GET_IVRS_SUCCESS:
      return {
        ...state,
        ivrs: action.payload.data,
        error: false,
        loading: false,
      };
    case GET_IVRS_ERROR:
      return {
        ...state,
        error: action.error,
        loading: true,
      };

    //update

    case UPDATE_A_IVR:
      return {
        ...state,
        ivr: [],
      };

    case UPDATE_A_IVR_SUCCESS: {
      const newData = state.ivrs.items.map((b) => {
        if (b.id == action.data.id) {
          b = action.data;
        }
        return b;
      });
      return {
        ...state,
        newData,
      };
    }

    case UPDATE_A_IVR_ERROR:
      return {
        ...state,
        error: action.error,
      };

    // create

    case CREATE_A_IVR:
      return {
        ...state,
      };

    case CREATE_A_IVR_SUCCESS:
      return {
        ...state,
        ivr: action.payload.data,
      };

    case CREATE_A_IVR_ERROR:
      return {
        ...state,
        error: action.error,
      };

    //delete
    case DELETE_A_IVR:
      return {
        ...state,
        ivr: [],
      };

    case DELETE_A_IVR_SUCCESS: {
      const data = state.ivr.filter((i) => i.id !== action.data.id);
      return {
        ...state,
        data,
      };
    }

    case DELETE_A_IVR_ERROR:
      return {
        ...state,
        error: action.error,
      };

    case GET_A_IVR_DETAIL_SUCCESS:
      return {
        ...state,
        ivr: action.payload,
      };

    default:
      return state;
  }
};

/**
 * Action
 */

export const getIvrsAction = () => ({
  type: GET_IVRS,
});

export const createAIvr = (aliasName, urlSound, menus) => ({
  type: CREATE_A_IVR,
  data: {
    aliasName,
    urlSound,
    ...menus,
  },
});

export const updateAIvr = (aliasName, urlSound, menus, id) => ({
  type: UPDATE_A_IVR,
  data: {
    aliasName,
    urlSound,
    ...menus,
    id,
  },
});

export const deleteAIvr = (id) => ({
  type: DELETE_A_IVR,
  data: {
    id,
  },
});

export const getIvrDetail = (id) => ({
  type: GET_A_IVR_DETAIL,
  data: {
    id,
  },
});

export const mapActionsIvrToProps = (dispatch) => {
  return bindActionCreators(
    {
      getIvrsAction: getIvrsAction,
      createAIvr,
      updateAIvr,
      deleteAIvr,
      getIvrDetail,
    },
    dispatch
  );
};

/**
 * Apis
 */

const getIvrsApi = () => {
  return apiCaller.get(`${process.env.REACT_APP_API_CONNECT}/ivrs`);
};

const createAIvrApi = (aliasName, urlSound, menus) => {
  return apiCaller.post(`${process.env.REACT_APP_API_CONNECT}/ivrs`, {
    aliasName,
    urlSound,
    ...menus,
  });
};

const updateAIvrApi = (aliasName, urlSound, menus, id) => {
  return apiCaller.put(`${process.env.REACT_APP_API_CONNECT}/ivrs/${id}`, {
    aliasName,
    urlSound,
    ...menus,
  });
};

const deleteAIvrApi = (id) => {
  return apiCaller.del(`${process.env.REACT_APP_API_CONNECT}/ivrs/${id}`);
};

/**
 * sagas
 */

export const getIvrsFlow = function* () {
  while (true) {
    yield take(GET_IVRS);
    try {
      const res = yield call(getIvrsApi);
      yield put({
        type: GET_IVRS_SUCCESS,
        payload: {
          ...res.data,
        },
      });
    } catch (error) {
      yield put({ type: GET_IVRS_ERROR, error });
    }
  }
};

export const createAIvrFlow = function* () {
  while (true) {
    const action = yield take(CREATE_A_IVR);
    try {
      const res = yield call(
        createAIvrApi,
        action.data.aliasName,
        action.data.urlSound,
        { ...action.data }
      );
      yield put({
        type: CREATE_A_IVR_SUCCESS,
        payload: { ...res.data },
        data: action.data,
      });
      const history = globalHistory();
      history.replace("/ivrs");
    } catch (error) {
      yield put({ type: CREATE_A_IVR_ERROR, error });
    }
  }
};

export const updateAIvrFlow = function* () {
  while (true) {
    const action = yield take(UPDATE_A_IVR);
    try {
      const res = yield call(
        updateAIvrApi,
        action.data.aliasName,
        action.data.urlSound,
        { ...action.data },
        action.data.id
      );
      yield put({
        type: UPDATE_A_IVR_SUCCESS,
        payload: {
          ...res.data,
        },
      });
    } catch (error) {
      yield put({ type: UPDATE_A_IVR_ERROR, error });
    }
  }
};

export const deleteAIvrFlow = function* () {
  while (true) {
    const action = yield take(DELETE_A_IVR);
    try {
      const res = yield call(deleteAIvrApi, action.data.id);
      yield put({
        type: DELETE_A_IVR_SUCCESS,
        payload: {
          ...res.data,
        },
        data: action.data,
      });
    } catch (error) {
      yield put({ type: DELETE_A_IVR_ERROR, error });
    }
  }
};

export const getIvrDetailFlow = function* () {
  while (true) {
    const action = yield take(GET_A_IVR_DETAIL);
    const ivrs = yield select((state) => state.ivr.ivrs.items);
    if (ivrs.length) {
      const _ivrs = ivrs.filter((b) => b.id == action.data.id);
      if (_ivrs.length == 1) {
        const ivr = _ivrs[0];
        yield put({ type: GET_A_IVR_DETAIL_SUCCESS, payload: ivr });
        continue;
      }
    }
    try {
      const rs = yield call(getIvrsApi);
      yield put({ type: GET_IVRS_SUCCESS, payload: rs.data.ivrs });
      const _ivrs = rs.data.data.items.filter((b) => b.id == action.data.id);
      if (_ivrs.length == 1) {
        const ivr = _ivrs[0];
        yield put({ type: GET_A_IVR_DETAIL_SUCCESS, payload: ivr });
        continue;
      } else {
        throw new AppError(null, "Không tìm thấy bản ghi này");
      }
    } catch (error) {
      const history = globalHistory();
      history.replace("/ivrs");
      yield put({ type: GET_A_IVR_DETAIL_ERROR, error });
    }
  }
};
